import vueI18n from '@/i18n/locale'

const AdvertiseIndex = () =>
  import(/* webpackChunkName: 'advertiseIndex' */ '@/pages/advertise/pages/index.vue')
const AdvertiseHome = () =>
  import(/* webpackChunkName: 'advertiseHome' */ '@/pages/advertise/pages/home/index.vue')
const AdvertiseCreate = () =>
  import(/* webpackChunkName: 'advertiseCreate' */ '@/pages/advertise/pages/create/index.vue')
const AdvertiseDetail = () =>
  import(/* webpackChunkName: 'advertiseDetail' */ '@/pages/advertise/pages/detail/index.vue')

const routes = [
  {
    path: '/advertise',
    name: 'advertise',
    redirect: '/advertise/home',
    component: AdvertiseIndex,
    children: [
      {
        path: 'home',
        name: 'AdvertiseHome',
        component: AdvertiseHome,
        meta: {
          title: vueI18n.t('FoodB_ads_WAjG_IoqX' /** 广告 */),
        },
      },
      {
        path: 'create',
        name: 'AdvertiseCreate',
        component: AdvertiseCreate,
        meta: {
          title: vueI18n.t('FoodB_ads_JrZk_DAPd' /* 创建我的广告计划 */),
        },
      },
      {
        path: 'edit',
        name: 'AdvertiseEdit',
        component: AdvertiseCreate,
        meta: {
          title: vueI18n.t('FoodB_ads_JrZk_DAPd' /* 创建我的广告计划 */),
        },
      },
      {
        path: 'sign-up',
        name: 'AdvertiseSignUp',
        component: AdvertiseCreate,
        meta: {
          title: vueI18n.t('FoodB_ads_JrZk_DAPd' /* 创建我的广告计划 */),
        },
      },
      {
        path: 'detail',
        name: 'AdvertiseDetail',
        component: AdvertiseDetail,
        meta: {
          title: vueI18n.t('FoodB_ads_kkCY_VhnR' /** 广告详情页 */),
        },
      },
    ],
  },
]

export default routes
